import * as React from 'react';
import AppContainer from './AppContainer';
import {CONTENT_TYPE} from '../../Config/appConfig';

class SearchContainer extends React.Component <{}, {}> {
    public render() {
        return (
            <AppContainer content={CONTENT_TYPE.SEARCH}/>
        );
    }
}

export default SearchContainer;



// WEBPACK FOOTER //
// ./src/Components/Containers/SearchContainer.tsx